import Vue from 'vue';
import { services, EventBus } from '../../Services/Services';
import orderList from '../../Components/order-list.vue';
import orderItemDetailOverlay from '../../Components/order-item-detail-overlay.vue';
import autocomplete from '../../Components/autocomplete.vue';
import mobileNavigationBar from '../../Components/mobile-navigation-bar.vue';
import deliveryMethods from '../../Components/delivery-methods.vue';
//import notificationBarCart from '../../Components/notification-bar-cart.vue';
import amzCart from '../../Components/amz-cart.vue';
import basketCount from '../../Components/basket-count.vue';
import shoppingCartService from '../../Services/ShopingCartService';
import deliveryTime from '../../Components/delivery-time.vue';
require('../../Services/Filters');

/**
 * The vue header app
 * Mainly just a wrapper around the search component
 */
new Vue({
    el: '#vue-header',
    components: { autocomplete, orderItemDetailOverlay, basketCount },
    data: function () {
        return {
            // return the shoppingcart model defined in services.js
            shoppingCart: shoppingCartService.shoppingCart
        }
    }
});


/**
 * The vue checkout app
 * Mainly just a wrapper around the basket component
 */
new Vue({

    el: '#vue-checkout',

    components: { amzCart, mobileNavigationBar, orderItemDetailOverlay, deliveryTime, deliveryMethods },

    data: function () {
        return {
            // return the shoppingcart model defined in services.js
            shoppingCart: shoppingCartService.shoppingCart,
            checkoutState: {
                showDesiredTimeTable: false,
                step : 'default'
            }
        }
    },
    
    mounted: function () {

        var _this = this;

        var _state = {
            selectedShipping: {}
        };
        
        // load shipping
        services.loadShippingMethods(null,
            function (methods) {
                selectState(methods.shippingmethods, true);
            },
            function (err) {
                console.log('error loading shipping methods');
                console.log(err);
            });

        function selectState(methods, init) {

            // Set _state.selectedShipping to the selected method
            for (var i in methods) {
                if (methods[i].selected) {
                    _state.selectedShipping = methods[i];
                }
            }

            // Reset values and styling

            $('.delivery-toggle input').each(function () {
                var $el = $(this);
                if ($el.val() === '-') {
                    $el.val('');
                }
            });
            
            // delivery-toggle
            $('.delivery-toggle').removeClass('d-none');
            $('.delivery-toggle').hide();

            // deselectShippingMethodDelivery
            $('.deselectShippingMethodDelivery').removeClass('d-none');
            $('.deselectShippingMethodDelivery').hide();

            // showDelivery
            $('.showDelivery').removeClass('d-none');
            $('.showDelivery').hide();

            // get-to-know
            $('.get-to-know').removeClass('d-none');
            $('.get-to-know').hide();


            // Show elements based on _state.selectedShipping.alias

            switch (_state.selectedShipping.alias) {
                case "bezorgen":
                    $('.delivery-toggle').show();
                    $('.deselectShippingMethodDelivery').show();
                    _this.checkoutState.showDesiredTimeTable = false;
                    _this.checkoutState.step = 'billingAddress_delivery_address';
                    break;
                case "afhalen":
                    _this.checkoutState.showDesiredTimeTable = true;
                    $('.showDelivery').show();
                    $('.get-to-know').show();
                    _this.checkoutState.step = 'billingAddress_pickup_desiredtime';
                    break;
                default:
                    _this.checkoutState.showDesiredTimeTable = false;
                    $('.showDelivery').show();
                    $('.get-to-know').show();
                    _this.checkoutState.step = 'default';
                    break;
            }

            $('.section.checkout .checkout-content .nicescroll-mod').getNiceScroll().resize();            
        }

        // callback handler, shippingmethod selection is processed by api, and returned here
        $(Amazilia).on('shippingMethodSubmited', function (e, data) {
            selectState(data.data.shippingmethods);
        });       
    },

    methods: {
        continueToDelivery: function () {

            var allFieldsAreValid = true;
            var form = $("form");
            var _this = this;

            // Required check
            form.find("input[required]").each(function () {
                if (!$(this).val().trim()) {
                    allFieldsAreValid = false;
                    $(this).addClass("input-validation-error");
                } else {
                    $(this).removeClass("input-validation-error");
                }
            });

            if (allFieldsAreValid) {
                Amazilia.sendBillingAddressForm(form.serialize(), '/umbraco/AmaziliaFoodTheme/FoodThemeCheckout/ApiAddressSubmit', function (result) {
                    if (result.success) {
                        
                        _this.checkoutState.showDesiredTimeTable = true;
                        _this.checkoutState.step = 'billingAddress_delivery_desiredtime';
                      //  $('.desiredTime').show();
                        $('.get-to-know').show();
                        $('.delivery-toggle').hide();
                        $('.showDelivery').show();

                    } else {
                        $('.checkoutResultMessage').html(result.message.join('<br/>'))
                    }
                });
            }
            else {
                // handle error
            }

            return false;
        }
    }
   
});

function getRequestHeader() {
    var cultureCode = '', storeId = '';

    if (window.pwa_currentCultureName) {
        cultureCode = window.pwa_currentCultureName;
    }

    if (window.pwa_storeId) {
        storeId = window.pwa_storeId;
    }

    // Always add @Html.AntiForgeryToken() to the page.
    var requestValidationToken = $('input:hidden[name="__RequestVerificationToken"]').val();

    return { 'PwaDisableCache': '1', 'cultureCode': cultureCode, 'storeId': storeId, 'RequestVerificationToken': requestValidationToken };
}



// WEBPACK FOOTER //
// ./Vue/Src/Areas/Checkout/main.js